import NumericItem from './NumericItem'

interface Props {
	items: {
		label: string
		status: 'active' | 'done' | 'pending'
		value?: string
		description?: string
	}[]
}

const KumopackNumericStepper: React.FC<Props> = ({ items }) => {
	return (
		<div className="card request-card-numeric border border-kumopack-grey-200">
			<div className="card-body px-0">
				{items.map(({ label, status, value, description }, idx) => (
					<NumericItem
						key={`kumopack-stepper-item-${label}-${idx}`}
						label={label}
						value={value ?? ''}
						description={description ?? ''}
					/>
				))}
			</div>
		</div>
	)
}

export default KumopackNumericStepper
